import { render } from "./LivePlayground.vue?vue&type=template&id=b9805312&scoped=true"
import script from "./LivePlayground.vue?vue&type=script&lang=js"
export * from "./LivePlayground.vue?vue&type=script&lang=js"

import "./LivePlayground.vue?vue&type=style&index=0&id=b9805312&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b9805312"],['__file',"src/components/LivePlayground.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b9805312"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b9805312', __exports__)) {
    api.reload('b9805312', __exports__)
  }
  
  module.hot.accept("./LivePlayground.vue?vue&type=template&id=b9805312&scoped=true", () => {
    api.rerender('b9805312', render)
  })

}


export default __exports__